import { VAT_ID_EU_NUMBER_MAX, VAT_ID_EU_NUMBER_MIN } from '@/constants';
export function validateUSAZipcode(str) {
  // eslint-disable-line
  // ^                 From the start of the ZIP code
  // [0-9]{5}          match a 5 digit ZIP code
  // (?!-0000$)        then assert that the PO box is NOT -0000
  // (?:-[0-9]{4})?    match an optional -xxxx PO box (which can't be 0000)
  // $                 end of the ZIP code
  if (!str.length) {
    return false;
  }
  const pattern = /^[0-9]{5}(?!-0000$)(?:-[0-9]{4})?$/;
  return pattern.test(str);
}
export function validateNotUSAZipCode(str) {
  // allow english letters, numbers, spaces and hyphens, max length = 20
  if (!str.length) {
    return false;
  }
  const pattern = /^(?!.{21})[a-zA-Z0-9]+(?:[- ][a-zA-Z0-9]+)*$/;
  return pattern.test(str);
}

export function validateFullName(name, isPaymentFormName = false) {
  if (!name.length) {
    return false;
  }

  // full name have to be more then 1 word
  const fullNameWordsCount = name.trim().split(/\s+/).length;
  if (fullNameWordsCount > 1) {
    if (name.match(/\d/)) {
      return false;
    }

    let pattern = '';

    if (isPaymentFormName) {
      // Allow only English letters, space, apostrophe, dot and dash between words
      pattern = /(?=^.{2,300}$)^[a-zA-Z]+(?:[-'. ][a-zA-Z]+)*$/;
    } else {
      // Allow any alphabets, space, apostrophe, dot and dash between words
      pattern = /^(?=.{2,300}$)(?!(?:.*-){2,4})\p{L}+(?:[-'. ]\p{L}+)*$/gu;
    }
    return pattern.test(name);
  }
  return false;
}

export function validateName(str) {
  if (!str.length || str.match(/\d/)) {
    return false;
  }
  // Allow any alphabets, space, apostrophe, dot and dash between words, min1-max 150 letters
  const pattern = /^(?=.{1,150}$)(?!(?:.*-){2,4})\p{L}+(?:[-'. ]\p{L}+)*$/gu;
  return pattern.test(str);
}

// exclude numbers and special character except '-'
export function validateStringExcludeNumbersAndSpecialCharacters(str) {
  if (!str) {
    return false;
  }

  const pattern = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
  return pattern.test(str);
}

// exclude special character except '-' and '.'
export function validateStringExcludeSpecialCharacters(str) {
  if (!str) {
    return false;
  }

  const pattern = /^[a-zA-Z]+(?:[\s.-][a-zA-Z0-9]+)*$/;
  return pattern.test(str);
}

export function isValidEmail(email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

// TODO: check all email validation and clean up
// this validation from fields components
export function validateEmail(email) {
  if (!email.length) {
    return false;
  }

  // max length 70 - MAX_EMAIL_LENGTH
  const pattern = /^(?!.{71})\S+@\S+\.\S+/;
  return pattern.test(email);
}

export function validateNumberLength(number, length) {
  if (!number?.length) {
    return false;
  }
  // allow only numbers
  const pattern = new RegExp(`^\\d{${length}}$`);
  return pattern.test(number);
}
export function validateEuropeanVatNumber(vatNumber) {
  if (!vatNumber?.length) {
    return false;
  }

  const createPattern = (min, max) => new RegExp(`^[a-zA-Z0-9]{${min},${max}}$`);
  const pattern = createPattern(VAT_ID_EU_NUMBER_MIN, VAT_ID_EU_NUMBER_MAX);
  return pattern.test(vatNumber);
}
